import React from "react";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      textAlign: "center",
      marginTop: "100px",
      background: "#222",
      color: "#fff",
      height: "100vh",
      paddingTop: "100px"
    }}>
      <h1>🔥 Mini Messenger</h1>
      <p>Chat in real-time with anyone</p>
      <button
        onClick={() => navigate("/signup")}
        style={{
          marginRight: "10px",
          padding: "10px 20px",
          fontSize: "16px"
        }}
      >
        Sign Up
      </button>
      <button
        onClick={() => navigate("/login")}
        style={{
          padding: "10px 20px",
          fontSize: "16px"
        }}
      >
        Log In
      </button>
    </div>
  );
};

export default Landing;